import { ListItem } from '../../core/models/list-item';
import * as actions from '../actions/site';
import { CoordinateList } from '../models/coordinate-list';

export interface State {
  loading: boolean;
  farms: ListItem[];
  sites: ListItem[];
  selectedSite: ListItem;
  authors: string[];
  farmGps: CoordinateList[];
  aocGps: CoordinateList[];
}

export const initialState: State = {
  loading: false,
  farms: [],
  sites: [],
  selectedSite: {},
  authors: [],
  farmGps: [],
  aocGps: []
};

export function reducer(state = initialState, action: any): State {
  let newState: State;
  let sites: ListItem[];
  let index: number;

  switch (action.type) {

    case actions.LOAD_ALL_FARMS:
      newState = Object.assign({}, state);
      newState.loading = true;
      return newState;

    case actions.LOAD_ALL_FARMS_COMPLETE:
      newState = Object.assign({}, state);
      newState.loading = false;
      newState.farms = action.payload;
      return newState;

    case actions.LOAD_ALL_SITES:
      newState = Object.assign({}, state);
      newState.loading = true;
      return newState;

    case actions.LOAD_ALL_SITES_COMPLETE:
      newState = Object.assign({}, state);
      newState.loading = false;
      newState.sites = action.payload;
      return newState;

    case actions.SELECT_SITE:
      newState = Object.assign({}, state);
      sites = newState.sites.slice();
      index = sites.map(s => s.abbreviation).indexOf(action.payload);
      if (index < 0) index = 0;
      newState.selectedSite = Object.assign(sites[index]);
      return newState;

    case actions.SELECT_SITE_BY_ID:
      newState = Object.assign({}, state);
      sites = newState.sites.slice();
      index = sites.map(s => s.id).indexOf(action.payload);
      newState.selectedSite = Object.assign(sites[index]);
      return newState;

    case actions.UPDATE_SITE:
      newState = Object.assign({}, state);
      newState.loading = true;
      return newState;

    case actions.UPDATE_SITE_COMPLETE:
      newState = Object.assign({}, state);
      newState.loading = false;
      newState.selectedSite = {};
      sites = newState.sites.slice();
      index = sites.map(s => s.id).indexOf(action.payload.id);
      sites.splice(index, 1, action.payload);
      newState.sites = [...sites];
      return newState;

    case actions.LOAD_AUTHORS:
      newState = Object.assign({}, state);
      newState.loading = true;
      return newState;

    case actions.LOAD_AUTHORS_COMPLETE:
      newState = Object.assign({}, state);
      newState.loading = false;
      newState.authors = action.payload;
      return newState;

    case actions.LOAD_FARM_GPS_COMPLETE:
      newState = Object.assign({}, state);
      newState.loading = false;
      newState.farmGps = action.payload;
      return newState;
    
    case actions.LOAD_AOC_GPS_COMPLETE:
      newState = Object.assign({}, state);
      newState.loading = false;
      newState.aocGps = action.payload;
      return newState;
      
    case 'ERROR':
      newState = Object.assign({}, state);
      newState.loading = false;
      return newState;

    default:
      newState = Object.assign({}, state);
      return newState;
  }
}

export const sites = (state: State) => state.sites;
export const selectedSite = (state: State) => state.selectedSite;
export const farms = (state: State) => state.farms;
export const loading = (state: State) => state.loading;
export const authors = (state: State) => state.authors;
export const farmGps = (state: State) => state.farmGps;
export const aocGps = (state: State) => state.aocGps;



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/reducers/site.ts